import './datepicker'
import './dropzone'
import './duplicate-name-confirmation'
import './form-save-shortcut'
import './form-hint-monitor'
import formattedTimestamp from './formatted-timestamp'
import './marketplace-archive-confirmation'
import availableModals from './modal-citizen/available-modals'
import setupModalCitizen from './modal-citizen/setup'
import './multi-file-upload-wrapper'
import './select-navigate'
import './white-label-preview'
import './sidepane'
import './submit_trigger'
import './../sections/quick-search'
import setupPeriodPickerTrigger from './setup-period-picker-trigger'
import setupPeriodPickerSidebarTrigger from './setup-period-picker-sidebar-trigger'
import { setupToastManager } from './setup-toast-manager'
import { isUsingNewLayout } from '@app/adapters/silverfin'

onDomLoad(function ($dom) {
  formattedTimestamp($dom[0])

  if (isUsingNewLayout()) {
    setupPeriodPickerSidebarTrigger($dom[0])
  } else {
    setupPeriodPickerTrigger($dom[0])
  }
})

setupModalCitizen(availableModals)
setupToastManager()
